import { Navigate } from 'react-router-dom';

const ProtectMobileRoute = () => {
    const storageId = localStorage.getItem('manageStoreId');
    const storeId = storageId && /^\d+$/.test(storageId) ? storageId : null;
    if (storeId) return <Navigate to={`/mobile/${storeId}`} replace />;
    return <Navigate to="/mobile/select-store" replace />;
};

export default ProtectMobileRoute;
